import React from "react";
import "./style.css";
export const Blog = () => {
  return (
    <div className="container">
      <div className="blog-page">
        <h1>Blog</h1>
      </div>
    </div>
  );
};
